/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { ThemeProvider } from '@material-tailwind/react';
import React, { useEffect } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './router';
import { getMaterialTailwindTheme, getCurrentTheme, getThemeColors } from './libs/common/themeConfig';
import { getSiteConfig } from './libs/common/siteConfig';
import { TopBar } from './components/TopBar';
import { useTranslation } from './libs/common/i18n';
import { SiteMetadata } from './components/SiteMetadata';
import { ToastContainer } from './components/Toast';
import { EventLibrary, EventLibraryProvider, EventLibraryContent } from './components/EventLibrary';

export const ResponsiveContainer = ({ children }) => {
  const siteConfig = getSiteConfig();
  const themeColors = getThemeColors();

  useEffect(() => {
    // Apply theme colors to document root
    const root = document.documentElement;
    root.style.setProperty('--theme-primary', themeColors.primary);
    root.style.setProperty('--theme-secondary', themeColors.secondary);
    root.style.setProperty('--theme-accent', themeColors.accent);
    root.style.setProperty('--theme-background', themeColors.background);
    root.style.setProperty('--theme-surface', themeColors.surface);
    root.style.setProperty('--theme-text', themeColors.text);
    root.style.setProperty('--theme-text-secondary', themeColors.textSecondary);
    root.style.setProperty('--theme-border', themeColors.border);
    // Set body background to match theme
    document.body.style.backgroundColor = themeColors.background;
    document.body.style.color = themeColors.text;
  }, [themeColors]);

  const Footer = () => {
    const { t } = useTranslation();
    return (
      <div
        className="relative w-full py-2"
      >
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6 xl:px-8">
          <div className="space-y-1 text-center">
            <div className="flex justify-center mb-1">
              <a
                href="https://twitter.com/CyberHono"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-200 hover:opacity-80"
                style={{
                  backgroundColor: themeColors.surface,
                  color: themeColors.text,
                  border: `1px solid ${themeColors.accent}`,
                }}
                aria-label="Follow @CyberHono on X"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="12"
                  height="12"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
                </svg>
                <span>Follow @CyberHono for my new projects</span>
              </a>
            </div>
            <p
              className="text-xs leading-snug"
              style={{ color: themeColors.textSecondary }}
            >
              by ieb (
              <a
                className="hyperlink font-medium transition-all duration-200 hover:opacity-80"
                href="https://twitter.com/CyberHono"
                style={{ color: themeColors.accent }}
              >
                @CyberHono
              </a>
              ) {t('footerCopyright')} &middot; Give{' '}
              <a
                className="hyperlink font-medium transition-all duration-200 hover:opacity-80"
                href="https://steamcommunity.com/id/iebbbb/"
                style={{ color: themeColors.accent }}
              >
                Steam award
              </a>
            </p>
            <p
              className="text-xs leading-snug"
              style={{ color: themeColors.textSecondary }}
            >
              {t('footerBusinessContact')}{' '}
              <a
                href="mailto:partner@majors.im"
                className="hyperlink font-medium transition-all duration-200 hover:opacity-80"
                style={{ color: themeColors.accent }}
              >
                partner@majors.im
              </a>
            </p>
          </div>
        </div>
        <img
          alt=""
          aria-hidden="true"
          className="absolute bottom-1 right-2 max-h-5 max-w-[120px]"
          src="https://www.counter12.com/img-Db8W78c5B9Z7y7wz-8.gif"
        />
      </div>
    );
  };

  return (
    <div
      className="event-page transition-colors duration-300"
      style={{ backgroundColor: themeColors.background, color: themeColors.text }}
    >
      <div className="outer no-sider">
        <div className="content-container">
          <main className="py-4 mx-auto w-full max-w-full">
            {children}
          </main>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: `<script defer data-domain="${siteConfig.analyticsDomain}" src="https://analytics.nekoko.it/js/script.js"></script>`,
          }}
        />
      </div>
      <Footer />
    </div>
  );
};


const HomepageLayout = () => {
  const themeName = getCurrentTheme();
  const customTheme = getMaterialTailwindTheme(themeName);

  return (
    <ThemeProvider value={customTheme}>
      <SiteMetadata />
      <Router>
        <EventLibraryProvider>
        <div className="application-layout">
        <TopBar />
        <div className="event-library-shell">
        <EventLibrary />
        <EventLibraryContent>
        <ResponsiveContainer>
          <Routes />
        </ResponsiveContainer>
        </EventLibraryContent>
        </div>
        <ToastContainer />
        </div>
        </EventLibraryProvider>
      </Router>
    </ThemeProvider>
  );
};

export default HomepageLayout;
